module.exports = __webpack_public_path__ + "static/media/third-reward.1639468d.svg";